






















































































import AppVue from "@/AppVue.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Question } from "../core/models/question.model";
import MultiLineString from "./MultiLineString.vue";

@Component({
  components: {
    MultiLineString,
  },
})
export default class QuestionCard extends AppVue {
  @Prop() currentNode: Question;
  @Prop({ default: true }) autoScroll: boolean;
  @Prop() answerCode: string;
  @Prop() language: string;
  @Prop() OnSelected: (code: string) => void;

  displayInfo = false;
  currentAnswerCode: any = null;
  @Watch("currentNode")
  OnCurrentNodeChange(val: Question, oldVal: Question) {
    this.currentAnswerCode = this.answerCode;
  }
  @Watch("currentAnswerCode")
  OnChangeAnswerCode(val: any, oldVal: any) {
    this.OnSelected(val);
  }

  showInfo() {
    this.displayInfo = true;
  }
  hideInfo() {
    this.displayInfo = false;
  }

  created() {
    this.currentAnswerCode = this.answerCode;
  }
}
